module.exports = __webpack_public_path__ + "media/img/trainings/coaches/coach-img-2-c898a293ed237afd2c4b0e39573a0a7e.jpeg";